import { baseQuery } from '../baseQuery';

type PutTechnicianRecurringAvailabilityPayload = {
  technicianId: number;
  recurringAvailabilityId: number;
  start_date: string;
  end_date: string;
  start_time: number;
  end_time: number;
  days: string[];
  setting: 'N' | 'C';
};

export const putTechnicianRecurringAvailability = async (payload: PutTechnicianRecurringAvailabilityPayload) => {
  const { technicianId, recurringAvailabilityId, ...rest } = payload;
  const { data } = await baseQuery(`technicians/${technicianId}/recurring-availabilities/${recurringAvailabilityId}`, {
    type: 'PUT',
    body: {
      ...rest,
    },
  });

  return data;
};
